export default __webpack_public_path__ + "static/sample2-21266513881848138a71841e2a7a3aa1.jpg";